import { useQueryCache } from "@pinia/colada";
import { CurrentUser, Role } from "@soft-db/monitoring-api-client";
import { Show } from "@soft-db/soft-utils";
import { Dialog, Divider, SoftSelect } from "@soft-db/ui";
import { defineComponent, ref } from "vue";
import { currentUserKeys } from "../api/current-user";
import { useKeys } from "../composable/keys";
import { __STAGING__ } from "../constants";
import PreferenceLocaleSelector from "./profile/PreferenceLocaleSelector.vue";
import PreferencesThemeSelector from "./profile/PreferencesThemeSelector.vue";

export default defineComponent({
	setup() {
		const open = ref(false);

		if (__STAGING__) {
			useKeys(
				["ctrl+b", "cmd+b"],
				() => {
					open.value = !open.value;
				},
				// TODO: Without disableInputCheck, it only work once. Need to check if it's a bug with new vue computed behavior.
				{ prevent: true, disableInputCheck: true }
			);
		}

		const cache = useQueryCache();
		function loadRole(role: Role) {
			cache.setQueryData(currentUserKeys.root, (oldUser: CurrentUser | undefined) => {
				if (oldUser) {
					return {
						...oldUser,
						role,
					};
				}

				return oldUser;
			});
		}

		return () => (
			<Show when={__STAGING__}>
				<Dialog v-model={open.value} class="w-100" actionText="Save">
					<div class="flex flex-col gap-2">
						<PreferencesThemeSelector />
						<Divider class="m-0!" />
						<PreferenceLocaleSelector />
						<Divider class="m-0!" />
						<div class="flex flex-col">
							<h2>Dev</h2>
							<div class="pl-2">
								<SoftSelect
									label="Load a role"
									modelValue=""
									items={[Role.viewer, Role.editor, Role.admin, Role.sys_admin]}
									onUpdate:modelValue={loadRole}
								/>
							</div>
						</div>
					</div>
				</Dialog>
			</Show>
		);
	},
});
